import Helper from './Helper';

class FootnoteIndent {
  constructor(config = {}) {
    const {
      listSelector,
      listItemSelector,
      listStyleSelector
    } = config;
    this.footnotes = [...document.querySelectorAll(listSelector)];
    this.footnoteItems = [...document.querySelectorAll(listItemSelector)];
    this.listStyleSelector = listStyleSelector;

    if(this.footnotes.length > 0){
      this.calcIndentation();
    }

    if(this.footnoteItems.length > 0){
      this.trimFootnoteItems();
    }
  }

  calcIndentation(){
    this.footnotes.forEach(list => {

      // V2
      let bulletPointItem = [...list.querySelectorAll(this.listStyleSelector)];
      let widestBulletPoint = 0;
      bulletPointItem.forEach(item => {
        let width = item.offsetWidth;

        if ( width > widestBulletPoint ) {
          widestBulletPoint = width;
        }
      });
      list.style.paddingLeft = widestBulletPoint + 'px';
    });
  }

  trimFootnoteItems(){
    this.footnoteItems.forEach(item => {
      item.innerHTML = item.innerHTML.replace(/\	/g,'').trim();
    })
  }
}

export default FootnoteIndent;
